var _ellipse, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryLarge = function SvgPrimaryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 241 241"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.277,
    cy: 120.405,
    fill: "#16242D",
    rx: 120,
    ry: 120.405
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.518,
    cy: 109.518,
    r: 108.018,
    stroke: "#ABB6BD",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "scale(.99831 1.00168)rotate(45 102.102 128.093)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.518,
    cy: 109.518,
    r: 105.518,
    stroke: "#ABB6BD",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "scale(.99831 1.00168)rotate(45 102.102 128.093)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ABB6BD",
    d: "m178.463 58.962 2.88.17.169 2.89 4.133 4.146-.629-10.721-10.685-.63z"
  })));
};
export default SvgPrimaryLarge;